import { useStructMemo as e } from "@maat/hooks";
import { useAuth as t, useMeQuery as n } from "@maat/store-auth";
//#region src/hooks/useMyProfile.ts
var r = () => {
	let { isAuthenticated: r } = t(), i = n(r).data?.user;
	return e({
		id: i?.id ?? "",
		email: i?.email ?? null,
		phone_e164: i?.phone_e164 ?? null,
		phone_verified_at: i?.phone_verified_at ?? null,
		first_name: i?.first_name ?? "",
		last_name: i?.last_name ?? "",
		avatar: i?.avatar ?? "",
		locale: i?.locale ?? "",
		preferred_currency: i?.preferred_currency ?? "USD",
		country_code: i?.country_code ?? null,
		country_source: i?.country_source ?? null,
		has_password: i?.has_password ?? !1,
		two_factor_enabled: i?.two_factor_enabled ?? !1,
		maat_creator_partner: i?.maat_creator_partner ?? !1,
		created_at: i?.created_at ?? "",
		updated_at: i?.updated_at ?? ""
	});
};
//#endregion
export { r as useMyProfile };
